import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	leftArrowlabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rightArrowlabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	leftArrowlabel: {
		id: 'version-issue-associated-designs.design-carousel.arrow.left-arrowlabel',
		defaultMessage: 'To next page',
		description: 'The accessbility label of the right icon button of design card carousel',
	},
	rightArrowlabel: {
		id: 'version-issue-associated-designs.design-carousel.arrow.right-arrowlabel',
		defaultMessage: 'To previous page',
		description: 'The accessbility label of the left icon button of design card carousel',
	},
});
export default messages;
